import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "p-field" }
const _hoisted_2 = {
  class: "p-field-label mt-1",
  for: "gateName"
}
const _hoisted_3 = { class: "p-field" }
const _hoisted_4 = { class: "p-field-label mb-2" }
const _hoisted_5 = { class: "d-flex mb-4" }
const _hoisted_6 = { class: "p-field" }
const _hoisted_7 = {
  class: "p-field-label mt-1",
  for: "scsAddr"
}
const _hoisted_8 = {
  for: "scsAddr",
  class: "fs-13 label-error"
}
const _hoisted_9 = {
  key: 0,
  class: "separator mt-3 mb-4 mx-3",
  style: {"background-color":"currentColor","opacity":"0.25"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")
  const _component_ButtonSelection = _resolveComponent("ButtonSelection")

  return (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.gatesToConfigure, (gate, key, index) => {
    return (_openBlock(), _createBlock(_Fragment, { key: key }, [
      _createVNode("div", _hoisted_1, [
        _createVNode("label", _hoisted_2, _toDisplayString(_ctx.$t("AppResourceEP.Name")), 1),
        _createVNode(_component_InputText, {
          id: "gateName",
          style: {"width":"40%"},
          modelValue: gate.gateName,
          "onUpdate:modelValue": ($event: any) => (gate.gateName = $event)
        }, null, 8, ["modelValue", "onUpdate:modelValue"])
      ]),
      _createVNode("div", _hoisted_3, [
        _createVNode("label", _hoisted_4, _toDisplayString(_ctx.$t("SelectDevicesInGate")), 1),
        _createVNode("div", _hoisted_5, [
          _createVNode(_component_ButtonSelection, {
            class: "ml-1 mr-4",
            icon: require(`@/assets/images/entrancePlants/icon-new-pe.svg`),
            label: _ctx.$t('AppResourceEP.NewPeDevice'),
            modelValue: gate.newPeSelected,
            "onUpdate:modelValue": ($event: any) => (gate.newPeSelected = $event),
            disabled: _ctx.newPeDisabled[index]
          }, null, 8, ["icon", "label", "modelValue", "onUpdate:modelValue", "disabled"]),
          _createVNode(_component_ButtonSelection, {
            class: "mr-4",
            icon: require(`@/assets/images/entrancePlants/icon-keypad.svg`),
            label: _ctx.$t('AppResourceEP.KeyPad'),
            modelValue: gate.keypadSelected,
            "onUpdate:modelValue": ($event: any) => (gate.keypadSelected = $event),
            disabled: _ctx.keypadDisabled[index]
          }, null, 8, ["icon", "label", "modelValue", "onUpdate:modelValue", "disabled"]),
          _createVNode(_component_ButtonSelection, {
            class: "mr-4",
            icon: require(`@/assets/images/entrancePlants/icon-smart-reader.svg`),
            label: _ctx.$t('AppResourceEP.SmartReader'),
            modelValue: gate.smartReaderSelected,
            "onUpdate:modelValue": ($event: any) => (gate.smartReaderSelected = $event),
            disabled: _ctx.smartReaderDisabled[index]
          }, null, 8, ["icon", "label", "modelValue", "onUpdate:modelValue", "disabled"])
        ])
      ]),
      _createVNode("div", _hoisted_6, [
        _createVNode("label", _hoisted_7, _toDisplayString(_ctx.$t("AppResourceEP.DeviceScsAddress")), 1),
        _createVNode(_component_InputText, {
          id: "scsAddr",
          class: {'input-error': _ctx.scsAddrNotValid[index]},
          type: "number",
          style: {"width":"40%"},
          min: _ctx.MIN_SCS_ADDRESS,
          max: _ctx.MAX_SCS_ADDRESS,
          modelValue: gate.scsAddress,
          "onUpdate:modelValue": ($event: any) => (gate.scsAddress = $event)
        }, null, 8, ["class", "min", "max", "modelValue", "onUpdate:modelValue"]),
        _createVNode("div", null, [
          _createVNode("label", _hoisted_8, _toDisplayString(_ctx.invalidScsReason[index]), 1)
        ])
      ]),
      (index < Object.keys(_ctx.gatesToConfigure).length - 1)
        ? (_openBlock(), _createBlock("hr", _hoisted_9))
        : _createCommentVNode("", true)
    ], 64))
  }), 128))
}